exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-header .navbar-nav .dropdown-menu-right {\n  right: auto; }\n", ""]);

// exports
